export default {
  path: '/configuracoes',
  component: () => import('@/components/pages/Settings/Settings.vue')
}
